export default __webpack_public_path__ + "static/media/waterfloor3.951a3f85.png";